import { apiCall, API_CONFIG } from '../config/api';

// Platform Integration Service for Meta Ads and TikTok
export class PlatformIntegrationService {
  constructor(userId) {
    this.userId = userId;
  }

  // Meta Ads Integration
  async connectMetaAds(accessToken, adAccountId) {
    try {
      const response = await apiCall('/api/connect-meta-ads', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId,
          accessToken,
          adAccountId
        })
      });
      return response;
    } catch (error) {
      console.error('Error connecting Meta Ads:', error);
      throw error;
    }
  }

  async fetchMetaAdsUGCData(adAccountId, dateRange = 'last_30d') {
    try {
      const response = await apiCall('/api/fetch-meta-ugc-data', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId,
          adAccountId,
          dateRange
        })
      });
      return response;
    } catch (error) {
      console.error('Error fetching Meta Ads UGC data:', error);
      throw error;
    }
  }

  // TikTok Integration
  async connectTikTok(accessToken, advertiserId) {
    try {
      const response = await apiCall('/api/connect-tiktok', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId,
          accessToken,
          advertiserId
        })
      });
      return response;
    } catch (error) {
      console.error('Error connecting TikTok:', error);
      throw error;
    }
  }

  async fetchTikTokUGCData(advertiserId, dateRange = 'last_30d') {
    try {
      const response = await apiCall('/api/fetch-tiktok-ugc-data', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId,
          advertiserId,
          dateRange
        })
      });
      return response;
    } catch (error) {
      console.error('Error fetching TikTok UGC data:', error);
      throw error;
    }
  }

  // UGC Performance Analysis
  async analyzeTopPerformingUGC(platform, data) {
    try {
      const response = await apiCall('/api/analyze-ugc-performance', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId,
          platform,
          data
        })
      });
      return response;
    } catch (error) {
      console.error('Error analyzing UGC performance:', error);
      throw error;
    }
  }

  // Brief Performance Analysis
  async analyzeBriefPerformance(platform, briefData) {
    try {
      const response = await apiCall('/api/analyze-brief-performance', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId,
          platform,
          briefData
        })
      });
      return response;
    } catch (error) {
      console.error('Error analyzing brief performance:', error);
      throw error;
    }
  }

  // Script Performance Analysis
  async analyzeScriptPerformance(platform, scriptData) {
    try {
      const response = await apiCall('/api/analyze-script-performance', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId,
          platform,
          scriptData
        })
      });
      return response;
    } catch (error) {
      console.error('Error analyzing script performance:', error);
      throw error;
    }
  }

  // Creator Performance Analysis
  async analyzeCreatorPerformance(platform, creatorData) {
    try {
      const response = await apiCall('/api/analyze-creator-performance', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId,
          platform,
          creatorData
        })
      });
      return response;
    } catch (error) {
      console.error('Error analyzing creator performance:', error);
      throw error;
    }
  }

  // Get Platform Connection Status
  async getConnectionStatus() {
    try {
      const response = await apiCall('/api/platform-connection-status', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId
        })
      });
      return response;
    } catch (error) {
      console.error('Error getting connection status:', error);
      throw error;
    }
  }

  // Disconnect Platform
  async disconnectPlatform(platform) {
    try {
      const response = await apiCall('/api/disconnect-platform', {
        method: 'POST',
        body: JSON.stringify({
          userId: this.userId,
          platform
        })
      });
      return response;
    } catch (error) {
      console.error('Error disconnecting platform:', error);
      throw error;
    }
  }
}

export const platformIntegrationService = new PlatformIntegrationService();


